// Central configuration file
// All environment-specific settings should be accessed from here

// Extract base URL without /api suffix
const getBaseUrl = () => {
    const envUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
    // Remove /api suffix if present to get the base URL
    return envUrl.replace(/\/api\/?$/, '');
};

const config = {
    // API Configuration
    // API_BASE_URL is the server root (e.g., http://localhost:5000)
    API_BASE_URL: getBaseUrl(),
    // API_URL is the full API endpoint (e.g., http://localhost:5000/api)
    API_URL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',

    // Meta/Facebook Configuration
    META_APP_ID: process.env.REACT_APP_META_APP_ID || '',

    // App Configuration
    APP_NAME: 'Getolli',
    APP_VERSION: '1.0.0',
};

// Helper function to get full API endpoint
// Note: This uses API_URL (with /api) as the base
export const getApiUrl = (endpoint) => {
    const baseUrl = config.API_URL;
    // Remove leading slash if present to avoid double slashes
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
    return `${baseUrl}/${cleanEndpoint}`;
};

// Helper for media/file URLs (images, uploads, etc.)
export const getMediaUrl = (path) => {
    if (!path) return '';
    // If already absolute URL, return as is
    if (path.startsWith('http://') || path.startsWith('https://')) {
        return path;
    }
    return `${config.API_BASE_URL}${path.startsWith('/') ? path : `/${path}`}`;
};

export default config;
